<section [ngClass]="dynamicClass" class="eq-relative eq-overflow-x-clip">
  <div class="eq-products-module" [ngClass]="{ 'products-module-bubbles': rendering.fields?.HasBubblesAnimation?.value === true }">
    <div class="eq-container eq-flex eq-flex-col eq-gap-y-5 eq-max-w-[950px] eq-mx-auto eq-text-center eq-mb-[60px]">
      <ng-container *ngIf="rendering?.fields?.H1TitleTag?.value">
        <h1 *ngIf="rendering.fields?.Title?.value" class="eq-text-heading2-m eq-font-bold eq-text-blue-darkBlue lg:eq-text-heading2">
          {{ rendering.fields?.Title?.value }}
        </h1>
      </ng-container>
      <ng-container *ngIf="!rendering?.fields?.H1TitleTag?.value">
        <h2 *ngIf="rendering.fields?.Title?.value" class="eq-text-heading2-m eq-font-bold eq-text-blue-darkBlue lg:eq-text-heading2">
          {{ rendering.fields?.Title?.value }}
        </h2>
      </ng-container>
      <div *ngIf="rendering.fields?.Subtitle?.value" class="eq-text-body-m eq-text-black-natural-60 lg:eq-text-body">
        {{ rendering.fields?.Subtitle?.value }}
      </div>
    </div>
    <div #CardProductsModuleSlider *ngIf="isMobile" class="swiper eq-container-left !eq-pb-6">
      <div class="swiper-wrapper">
        <!-- for i = 0 => i = 4 -->
        <ng-container *ngFor="let card of cards; let first=first;">
          <div class="swiper-slide !eq-w-[284px] !eq-h-auto">
            <app-card-product [ngClass]="first ? 'product-card-large' : ''" [cardData]="card"></app-card-product>
          </div>
        </ng-container>
      </div>
    </div>
    <div *ngIf="!isMobile" class="eq-cards-desktop eq-container eq-flex eq-w-full eq-space-x-4">
      <div class="eq-flex eq-w-[40%] eq-max-w-[589px]">
        <app-card-product 
          class="product-card-large"
          [cardData]="cards[0]"
        ></app-card-product>
      </div>
      <div class="eq-grid eq-grid-cols-2 eq-grid-rows-2 eq-w-[60%] eq-gap-5">
        <ng-container *ngFor="let card of cards | slice:1">
          <app-card-product 
            [cardData]="card" class="eq-max-w-[403px]"
          ></app-card-product>
        </ng-container>
      </div>
    </div>
  </div>
</section>